var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g3, _rect, _g4, _g5, _g6, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g7, _path43, _path44, _g8, _path45, _path46, _path47, _path48, _path49, _g9, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _path65, _path66;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 619.985,
    height: 371.713,
    viewBox: "0 0 619.985 371.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0 -0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(0 0)",
    opacity: 0.25
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(11.919 264.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M162.474,497.638l-25.931,2.875V429.6l25.931-10.73Z",
    transform: "translate(-136.542 -418.865)",
    fill: "rgba(46,173,212,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M188.174,500.412l-28.968-.932v-80.6l28.968,3.717Z",
    transform: "translate(-133.276 -418.864)",
    fill: "rgba(46,173,212,0.46)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M271.578,532.725H176V415.507l95.579-40.125Z",
    transform: "translate(-118.937 -161.003)",
    fill: "rgba(237,247,250,0.87)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M324.3,532.727H259.539V375.366L324.3,389.451Z",
    transform: "translate(-106.898 -161.005)",
    fill: "rgba(237,247,250,0.87)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M271.862,388.792l-97.828,37.785V412.445l97.828-42.777Z",
    transform: "translate(-119.22 -161.826)",
    fill: "rgba(237,247,250,0.87)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M271.862,424.722l-97.828,26.609v-5.394l97.828-28.516Z",
    transform: "translate(-119.22 -154.944)",
    fill: "rgba(46,173,212,0.46)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M334.88,403.868,259.539,388.8V369.684l75.341,17.062Z",
    transform: "translate(-106.898 -161.824)",
    fill: "rgba(46,173,212,0.46)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M334.88,435.35l-75.341-10.613v-7.313L334.88,428.8Z",
    transform: "translate(-106.898 -154.944)",
    fill: "rgba(46,173,212,0.46)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(549.647 176.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M668.2,536.634l-25.51-.087V342.081l25.51,17.482Z",
    transform: "translate(-601.329 -342.081)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M647.9,536.617l-41.364.046V352.026l41.364-9.942Z",
    transform: "translate(-606.539 -342.081)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(4 23.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M610.035,456.418l4.29-.366V440.588l-4.29.458Z",
    transform: "translate(-610.035 -351.483)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M634.034,439.49V423.549l-4.6.589v15.843Z",
    transform: "translate(-607.24 -353.938)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M629,364.86l-4.518.963v15.7l4.518-.868Z",
    transform: "translate(-607.953 -362.396)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M634.034,363.789l-4.6.981v15.821l4.6-.884Z",
    transform: "translate(-607.24 -362.55)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M619.615,455.631l4.427-.378v-15.7l-4.427.473Z",
    transform: "translate(-608.654 -351.632)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M614.326,367.984l-4.29.915v15.353l4.29-.824Z",
    transform: "translate(-610.035 -361.945)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M624.042,365.916l-4.427.944v15.583l4.427-.85Z",
    transform: "translate(-608.654 -362.244)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M619.167,410.83l-4.382.654v15.481l4.382-.562Z",
    transform: "translate(-609.35 -355.771)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M619.615,396.139v15.59l4.427-.66V395.383Z",
    transform: "translate(-608.654 -357.997)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M624.042,440.524v-15.7l-4.427.568V441Z",
    transform: "translate(-608.654 -353.754)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M619.167,396.215l-4.382.749v15.47l4.382-.654Z",
    transform: "translate(-609.35 -357.877)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M614.326,411.55l-4.29.64v15.367l4.29-.55Z",
    transform: "translate(-610.035 -355.667)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M624.484,380.554v15.735l4.518-.772V379.686Z",
    transform: "translate(-607.953 -360.259)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M614.785,382.415v15.5l4.382-.749V381.572Z",
    transform: "translate(-609.35 -359.987)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M634.455,439.461l4.668-.5V422.9l-4.668.6Z",
    transform: "translate(-606.516 -354.032)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M614.326,397.04l-4.29.733v15.352l4.29-.639Z",
    transform: "translate(-610.035 -357.758)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M634.455,409.568l4.668-.7v-16.06l-4.668.8Z",
    transform: "translate(-606.516 -358.368)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M629.434,454.824l4.6-.393V438.487l-4.6.492Z",
    transform: "translate(-607.24 -351.785)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M629.434,425.135l4.6-.589V408.617l-4.6.686Z",
    transform: "translate(-607.24 -356.09)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M619.615,381.488V397.1l4.427-.756v-15.71Z",
    transform: "translate(-608.654 -360.122)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M619.167,441.029V425.45l-4.382.562V441.5Z",
    transform: "translate(-609.35 -353.664)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M634.455,379.643l4.668-.9v-16.04l-4.668,1Z",
    transform: "translate(-606.516 -362.706)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M624.484,411.019l4.518-.672v-15.81l-4.518.772Z",
    transform: "translate(-607.953 -358.119)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M624.042,425.794V410.1l-4.427.66v15.6Z",
    transform: "translate(-608.654 -355.876)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M614.326,426.069l-4.29.55v15.368l4.29-.458Z",
    transform: "translate(-610.035 -353.575)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M629,440.01V424.191l-4.518.579v15.723Z",
    transform: "translate(-607.953 -353.845)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M614.326,382.5l-4.29.824v15.382l4.29-.733Z",
    transform: "translate(-610.035 -359.853)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M629,425.175v-15.81l-4.518.674v15.715Z",
    transform: "translate(-607.953 -355.982)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M619.167,366.954l-4.382.935v15.466l4.382-.841Z",
    transform: "translate(-609.35 -362.094)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M624.484,455.231l4.518-.387V439.023l-4.518.483Z",
    transform: "translate(-607.953 -351.708)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M634.455,424.509l4.668-.6V407.859l-4.668.7Z",
    transform: "translate(-606.516 -356.199)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M629.434,410.3l4.6-.686V393.68l-4.6.786Z",
    transform: "translate(-607.24 -358.243)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M614.785,456.027l4.382-.373V440.072l-4.382.468Z",
    transform: "translate(-609.35 -351.557)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M634.455,454.412l4.668-.4V437.945l-4.668.5Z",
    transform: "translate(-606.516 -351.864)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M629.434,395.46l4.6-.787V378.721l-4.6.884Z",
    transform: "translate(-607.24 -360.398)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M634.455,394.62l4.668-.8V377.744l-4.668.9Z",
    transform: "translate(-606.516 -360.539)",
    fill: "rgba(240,252,255,0.46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(45.291 24.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M652.244,382.1v15.691l2.233,1.085V383.32Z",
    transform: "translate(-645.243 -360.808)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M651.535,411.489l-2.31-.98v16.02l2.31.838Z",
    transform: "translate(-645.678 -356.713)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M651.535,396.58l-2.31-1.125v15.98l2.31.981Z",
    transform: "translate(-645.678 -358.883)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M654.477,368.587l-2.233-1.362v15.711l2.233,1.222Z",
    transform: "translate(-645.243 -362.951)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M651.535,442.289V426.413l-2.31-.838V441.6Z",
    transform: "translate(-645.678 -354.542)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M651.535,366.792l-2.31-1.411v15.927l2.31,1.267Z",
    transform: "translate(-645.678 -363.217)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M649.225,456.663l2.31.551v-15.9l-2.31-.694Z",
    transform: "translate(-645.678 -352.374)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M648.527,425.322l-2.4-.869v16.241l2.4.72Z",
    transform: "translate(-646.125 -354.704)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M648.527,410.213l-2.4-1.018v16.239l2.4.869Z",
    transform: "translate(-646.125 -356.903)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M649.225,380.442v15.9l2.31,1.124V381.708Z",
    transform: "translate(-645.678 -361.046)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M646.125,455.953l2.4.572V440.412l-2.4-.721Z",
    transform: "translate(-646.125 -352.508)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M648.527,395.116l-2.4-1.168v16.2l2.4,1.018Z",
    transform: "translate(-646.125 -359.1)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M648.527,380.06l-2.4-1.317v16.125l2.4,1.168Z",
    transform: "translate(-646.125 -361.291)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M660.885,459.338l1.991.475v-15.1l-1.991-.6Z",
    transform: "translate(-643.998 -351.87)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M660.885,401.913l1.991.967V387.922l-1.991-1.09Z",
    transform: "translate(-643.998 -360.125)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M660.885,430.65l1.991.721V416.3l-1.991-.845Z",
    transform: "translate(-643.998 -356.001)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M660.885,444.989l1.991.6V430.52l-1.991-.721Z",
    transform: "translate(-643.998 -353.933)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M660.885,387.593l1.991,1.092V373.714l-1.991-1.216Z",
    transform: "translate(-643.998 -362.191)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M658.074,458.694l2.071.493V443.9l-2.071-.621Z",
    transform: "translate(-644.403 -351.991)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M660.885,416.275l1.991.844V402.095l-1.991-.969Z",
    transform: "translate(-643.998 -358.066)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M654.477,443.144V427.478l-2.233-.808v15.805Z",
    transform: "translate(-645.243 -354.384)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M657.345,429.419V413.952l-2.149-.912v15.6Z",
    transform: "translate(-644.818 -356.349)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M657.345,370.338l-2.149-1.313v15.5l2.149,1.178Z",
    transform: "translate(-644.818 -362.692)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M652.244,457.356l2.233.532V442.2l-2.233-.669Z",
    transform: "translate(-645.243 -352.243)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M655.2,458.033l2.149.513V443.058l-2.149-.646Z",
    transform: "translate(-644.818 -352.116)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M657.345,443.978v-15.46l-2.149-.78v15.6Z",
    transform: "translate(-644.818 -354.23)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M655.2,413.913l2.149.912v-15.42l-2.149-1.046Z",
    transform: "translate(-644.818 -358.464)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M655.2,383.714V399.2l2.149,1.046V384.893Z",
    transform: "translate(-644.818 -360.575)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M660.146,444.792v-15.26l-2.071-.75v15.39Z",
    transform: "translate(-644.403 -354.08)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M658.074,415.109l2.071.877v-15.22l-2.071-1.007Z",
    transform: "translate(-644.403 -358.262)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M658.074,429.657l2.071.75V415.139l-2.071-.877Z",
    transform: "translate(-644.403 -356.173)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M658.074,400.572l2.071,1.007V386.426l-2.071-1.134Z",
    transform: "translate(-644.403 -360.347)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M660.146,372.047l-2.071-1.264v15.3l2.071,1.134Z",
    transform: "translate(-644.403 -362.438)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M654.477,428.4V412.735l-2.233-.946V427.6Z",
    transform: "translate(-645.243 -356.529)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M652.244,396.925v15.764l2.233.946V398.01Z",
    transform: "translate(-645.243 -358.671)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M648.527,364.955l-2.4-1.466v16.148l2.4,1.316Z",
    transform: "translate(-646.125 -363.489)",
    fill: "rgba(240,252,255,0.46)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(454.775 218.989)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M532.375,519.068l49.38-.029V467.286l-49.38,3.5Z",
    transform: "translate(-522.355 -366.748)",
    fill: "rgba(240,252,255,0.46)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M575.377,519.659h84.664V478.58l-84.664-12.529Z",
    transform: "translate(-516.158 -366.926)",
    fill: "rgba(240,252,255,0.46)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M575.377,484.077l90.385,11.977v-78.2l-90.385-37.981Z",
    transform: "translate(-516.158 -379.345)",
    fill: "rgba(240,252,255,0.46)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M523.617,488.62l59.212-3.807V379.437l-59.212,12.282Z",
    transform: "translate(-523.617 -379.407)",
    fill: "rgba(240,252,255,0.46)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M666.407,417.918h-.572l.221-.527-90.392-37.98-.221.527h-.572V484.217h.572l-.075.568,90.393,11.9.074-.567h.572ZM620.068,443.8l-13.921-3.841V417.3l13.921,4.846Zm1.144-21.252,13.919,4.845v20.564l-13.919-3.841ZM605,439.64,591.081,435.8v-23.74L605,416.9Zm0,1.188v22.759l-13.922-2.836V436.986Zm1.144.315,13.921,3.842v21.673l-13.921-2.836Zm15.066,4.158,13.919,3.841v20.587l-13.919-2.837Zm15.063,4.157L650.2,453.3v19.5l-13.922-2.837Zm0-1.187V427.786l13.922,4.846V452.11Zm0-21.693V406.119l13.922,5.849V431.42Zm-1.144-.4-13.919-4.844V399.79l13.919,5.849Zm-15.063-5.243-13.921-4.844V393.46l13.921,5.85ZM605,415.691l-13.922-4.845V387.129L605,392.979Zm-15.066-5.244L576.015,405.6V380.8l13.921,5.85Zm0,1.213v23.824l-13.921-3.841V406.814Zm0,25.011v23.847l-13.921-2.839V432.829Zm0,25.015v23.864l-13.921-1.834V458.848Zm1.144.232L605,464.756v22.776L591.081,485.7Zm15.066,3.071,13.921,2.839v21.689l-13.921-1.833Zm15.066,3.072,13.919,2.836v20.6l-13.919-1.833Zm15.063,3.07,13.922,2.837v19.516l-13.922-1.833Zm15.066,3.071,13.921,2.836v18.432l-13.921-1.834Zm0-1.169V453.614l13.921,3.841V475.87Zm0-20.605V433.031l13.921,4.845v18.391Zm0-20.607v-19.37l13.921,5.849v18.365Z",
    transform: "translate(-516.231 -379.411)",
    fill: "rgba(240,252,255,0.46)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M598.623,515.723l34.9.149V486.859l-34.9-3.517Z",
    transform: "translate(-512.808 -364.434)",
    fill: "rgba(240,252,255,0.46)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M633.521,496.609v-9.749l-34.9-3.517v14.166Z",
    transform: "translate(-512.808 -364.434)",
    fill: "rgba(240,252,255,0.46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(86.061 120.055)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M631.139,489.557v-3.071l-5.479-.552-10.513,29.5,6.76.029Z",
    transform: "translate(-596.488 -484.115)",
    fill: "rgba(240,252,255,0.46)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M598.838,515.58l11.044.047,10.766-30.206-10.677-1.077Z",
    transform: "translate(-598.838 -484.344)",
    fill: "rgba(240,252,255,0.46)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M614.8,516.031l.8,0V485.052l-.8-.079Z",
    transform: "translate(-510.476 -364.199)",
    fill: "rgba(240,252,255,0.46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(325.207 117.23)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M536.687,310.265l-8.161,2.741-.842-.465,8.167-2.752Z",
    transform: "translate(-393.463 -287.685)",
    fill: "rgba(240,252,255,0.46)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M522.105,301.962l-8.286,2.969-.909-.5,8.292-2.981Z",
    transform: "translate(-395.592 -288.886)",
    fill: "rgba(240,252,255,0.46)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M504.552,291.971l-8.413,3.255-1-.549,8.422-3.269Z",
    transform: "translate(-398.152 -290.333)",
    fill: "rgba(240,252,255,0.46)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M495.842,499.469l-85.473,5.9V335.306l85.473-32.462Z",
    transform: "translate(-410.369 -288.685)",
    fill: "rgba(240,252,255,0.46)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M540.545,508.018l-55.469-4.756V302.846l55.469,28.637Z",
    transform: "translate(-399.603 -288.685)",
    fill: "rgba(240,252,255,0.46)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(8.588 42.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 0.001,
    height: 0.006,
    transform: "translate(50.374 2.364)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M427.473,445.879V403.216l17.917-4.067v44.089Zm39.632-5.844V394.219l-19.427,4.409V442.9Zm2.288-.336,9.2-1.357v-46.73l-9.2,2.089Zm-44.208-35.964-7.31,1.659v41.9l7.31-1.078Z",
    transform: "translate(-417.875 -318.047)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M469.393,376.422l9.2-2.453V327.313l-9.2,3.18Zm-24-37.608-17.917,6.2V387.6l17.917-4.78Zm21.715-7.519-19.427,6.726v44.193l19.427-5.182Zm-41.92,14.515-7.31,2.529v41.825l7.31-1.951Z",
    transform: "translate(-417.875 -327.313)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M427.473,383.8v20.163l17.917-4.066V379.017Zm41.92,10.648,9.2-2.089v-22.2l-9.2,2.455Zm-21.715,4.928,19.427-4.408V373.225l-19.427,5.182Zm-22.493-14.966-7.31,1.95v19.782l7.31-1.659Z",
    transform: "translate(-417.875 -321.138)",
    fill: "rgba(240,252,255,0.46)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 0.001,
    height: 0.006,
    transform: "translate(58.962 44.517)",
    fill: "rgba(240,252,255,0.46)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(8.588 42.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M444.18,337.414l-17.917,6.165v6.706L444.18,356.6Z",
    transform: "translate(-416.666 -325.989)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M425.184,348.6v-5.111l-6.456,2.222-.854.295v.016Z",
    transform: "translate(-417.875 -325.113)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M463.351,330.883l-19.427,6.685v20.785l19.427,6.851Z",
    transform: "translate(-414.121 -326.93)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M472.1,327.428l-9.2,3.165v35.915l9.2,3.245Z",
    transform: "translate(-411.386 -327.428)",
    fill: "rgba(240,252,255,0.46)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(8.588 91.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M444.18,377.951l-17.917,4.741v5.175l17.917,4.859Z",
    transform: "translate(-416.666 -369.164)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M425.184,386.574v-3.95l-6.61,1.75-.7.187v.031Z",
    transform: "translate(-417.875 -368.49)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M463.351,394.565V372.928l-19.427,5.142v16l9.846,2.669Z",
    transform: "translate(-414.121 -369.888)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M462.9,372.705v21.724l9.2-2.088v-22.07Z",
    transform: "translate(-411.386 -370.271)",
    fill: "rgba(240,252,255,0.46)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(8.594 115.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M444.18,398.233l-17.917,4.029v4.386l17.917,4.128Z",
    transform: "translate(-416.673 -390.768)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M425.184,405.549v-3.341l-7.3,1.657Z",
    transform: "translate(-417.881 -390.195)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M463.351,393.966l-19.427,4.369V411.92l19.427,4.476Z",
    transform: "translate(-414.128 -391.383)",
    fill: "rgba(240,252,255,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M472.1,391.708l-9.2,2.068v23.472l9.2,2.12Z",
    transform: "translate(-411.393 -391.708)",
    fill: "rgba(240,252,255,0.46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(8.588 42.153)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M426.264,343.568v42.587l9.555-2.55,8.362-24.339v-21.9Z",
    transform: "translate(-416.666 -325.864)",
    fill: "rgba(240,252,255,0.46)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M441.937,395.908l-.1.3.1-.023Z",
    transform: "translate(-414.422 -317.427)",
    fill: "rgba(240,252,255,0.46)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M443.924,352.979l6.253-18.2-6.253,2.165Z",
    transform: "translate(-414.121 -326.236)",
    fill: "rgba(240,252,255,0.46)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M426.264,402.143l.145-.418-.145.032Z",
    transform: "translate(-416.666 -316.589)",
    fill: "rgba(240,252,255,0.46)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M417.875,404.344l7.309-1.659V382.612l-7.309,1.95Z",
    transform: "translate(-417.875 -319.343)",
    fill: "rgba(240,252,255,0.46)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M462.545,340.661l-13.028,37.922,13.028-3.475Z",
    transform: "translate(-413.315 -325.389)",
    fill: "rgba(240,252,255,0.46)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M426.264,382.37v20.163l1.019-.231,7.642-22.242Z",
    transform: "translate(-416.666 -319.711)",
    fill: "rgba(240,252,255,0.46)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M443.924,398.157V436.8l14.4-41.917Z",
    transform: "translate(-414.121 -317.574)",
    fill: "rgba(240,252,255,0.46)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M417.875,387.835l7.309-1.951v-42.4l-2.215.766-5.095,14.832Z",
    transform: "translate(-417.875 -324.983)",
    fill: "rgba(240,252,255,0.46)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M472.1,327.313l-7.081,2.448-2.118,6.164v40.5l2.614-.7,6.585-19.166Z",
    transform: "translate(-411.386 -327.313)",
    fill: "rgba(240,252,255,0.46)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M463.351,372.839l-13.924,3.714-5.5,16.02v6.414l15.276-3.466,4.152-12.087Z",
    transform: "translate(-414.121 -320.752)",
    fill: "rgba(240,252,255,0.46)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M462.9,372.364v4.544l1.721-5Z",
    transform: "translate(-411.386 -320.886)",
    fill: "rgba(240,252,255,0.46)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M425.184,408.734v-6.526l-7.309,1.659v26.146Z",
    transform: "translate(-417.875 -316.519)",
    fill: "rgba(240,252,255,0.46)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M444.053,398.2l-.977.221L427.15,444.78l16.9-2.491Z",
    transform: "translate(-416.538 -317.097)",
    fill: "rgba(240,252,255,0.46)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M488.711,377.578l48.629,17.641V317.448l-48.629-26.8Z",
    transform: "translate(-399.079 -290.443)",
    fill: "rgba(240,252,255,0.46)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M492.6,374.737l40.546,15.034V318.046L492.6,296.027Z",
    transform: "translate(-398.519 -289.668)",
    fill: "rgba(240,252,255,0.46)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M534.315,310.594l2.25,1.276V310.2l-2.25-1.283Z",
    transform: "translate(-392.507 -287.81)",
    fill: "rgba(240,252,255,0.46)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M519.641,302.294l2.438,1.381v-1.736l-2.438-1.392Z",
    transform: "translate(-394.622 -289.016)",
    fill: "rgba(240,252,255,0.46)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M501.969,292.3l2.675,1.515v-1.819l-2.675-1.525Z",
    transform: "translate(-397.169 -290.469)",
    fill: "rgba(240,252,255,0.46)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M488.711,385.7,537.34,401.12v-4.454l-48.629-15.939Z",
    transform: "translate(-399.079 -277.462)",
    fill: "rgba(240,252,255,0.46)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M488.711,410.435l48.629,12.433v-4.453l-48.629-12.957Z",
    transform: "translate(-399.079 -273.898)",
    fill: "rgba(240,252,255,0.46)"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M221.894,518.864l65.492.061V471.133l-65.492-4.525Z",
    transform: "translate(-112.323 -147.856)",
    fill: "rgba(46,173,212,0.46)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M235.086,518.956l-104.877.221V482.993L235.086,466.04Z",
    transform: "translate(-125.536 -147.938)",
    fill: "rgba(46,173,212,0.46)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(187.92 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 81.459, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M49.775,23.377l-1.653.838L0,.988,1.636,0Z",
    transform: "translate(0 23.733)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M0,24.892l1.635-.987V0L0,1.066Z",
    transform: "translate(0.035 0.007)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M0,23.9,47.949,47.17V25.154L0,0Z",
    transform: "translate(1.667 0)",
    fill: "rgba(222,247,255,0.65)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M290.375,604.412l67.314-.136V250.617l-67.314,50Z",
    transform: "translate(-290.375 -233.393)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M415.187,605.114H349.212V250.621l65.975,37.664Z",
    transform: "translate(-281.895 -233.392)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M401.752,344.841l5.516,2.631v37.952l-5.516-2.227ZM393.72,464.25l5.743,1.48V426.968l-5.743-1.9ZM391.432,505.9V466.585l-5.959-1.535V504.8Zm-5.959,41.6,5.959.663V508.8l-5.959-1.1Zm8.248.917,5.743.638V510.278l-5.743-1.057Zm0-126.314,5.743,1.9V385.285l-5.743-2.32Zm8.032-80.33,5.516,2.631V306.37l-5.516-3.033Zm-8.032,38.177,5.743,2.32V343.751l-5.743-2.74Zm8.032,86.368,5.516,1.42V429.55l-5.516-1.825Zm-2.288-164.243-5.743-3.16v39.026l5.743,2.74Zm0,205.3V468.656l-5.743-1.48v39.149Zm2.288,41.927,5.516.612V511.714l-5.516-1.014Zm0-41.506,5.516,1.016V470.666l-5.516-1.421Zm0-83.042,5.516,1.824V388.436l-5.516-2.228Zm-27.093-49.493-6.441-2.6v41l6.441,2.129Zm-6.441-46.423v40.81l6.441,2.6V331.918Zm14.966-35.724-6.237-3.432v40.254l6.237,2.975Zm0,211.263V464.462l-6.237-1.606v40.38Zm0-42.847V421.583l-6.237-2.062V459.93Zm8.248,2.125v-39.35l-5.959-1.971v39.785Zm-5.959-44.284,5.959,1.972V382.041l-5.959-2.407Zm0-82.3v39.546l5.959,2.407v-39.11Zm5.959-39.418-5.959-3.28v39.63l5.959,2.843Zm-14.484,248.9,6.237.692V507.28l-6.237-1.149Zm0-170.364v40.365l6.237,2.063V378.71Zm0-43.181v40.169l6.237,2.519V335.985Zm-2.288,85.753-6.441-2.129V457.68l6.441,1.661Zm-6.441,126.824,6.441.715V505.71l-6.441-1.186Zm6.441-42.774V462.267l-6.441-1.661v41.022Zm0-214.384-6.441-3.544v40.893l6.441,3.072ZM365.93,460.017l-6.716-1.731V499.97l6.716,1.237Zm-6.716,84.57,6.716.745V504.1l-6.716-1.235Zm6.716-128.709-6.716-2.221v41.7l6.716,1.731Zm0-44.135-6.716-2.713v41.662l6.716,2.221Zm0-88.115-6.716-3.7v41.55l6.716,3.2Zm0,44.127-6.716-3.205v41.469l6.716,2.711Z",
    transform: "translate(-280.454 -229.168)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M338.354,355.233l6.865-2.872v32.656l-6.865,2.357Zm0,135.91,6.865-.8V457.549l-6.865,1.323Zm0-34.6,6.865-1.324V422.506l-6.865,1.839Zm0-34.565,6.865-1.839v-32.7l-6.865,2.356Zm0-103.793,6.865-3.389V282.268l-6.865,3.9Zm-8.786,173.988,6.5-.762v-32.1l-6.5,1.252Zm-1.144-201.664v.006h0Zm7.641-3.034-6.5,3.7v31.35l6.5-3.207Zm0,169.509V424.958l-6.5,1.742v31.534Zm-6.5-32.651,6.5-1.742V390.577l-6.5,2.231Zm0-33.943,6.5-2.23V356.19l-6.5,2.718Zm-2.288,34.556v-31.35l-6.168,2.117V426.6Zm2.288-68.517,6.5-2.718V321.865l-6.5,3.209Zm-8.456,136.737,6.168-.723V461.007l-6.168,1.189Zm6.168-34.488V427.312l-6.168,1.652v30.9Zm11.074-105.925,6.865-2.872V317.346l-6.865,3.39ZM327.28,292.486,321.113,296v30.7l6.168-3.044Zm-8.456,134.723V396.5l-5.869,2.016v30.27Zm-5.869-61.351v30.233l5.869-2.015V363.4Zm0-32.584v30.1l5.869-2.455V330.377Zm5.869-35.976-5.869,3.34v30.085l5.869-2.9Zm-8.157,102-5.548,1.9v29.679l5.548-1.486Zm2.288,94.821,5.869-.688V462.637l-5.869,1.132Zm5.869-33.813V429.578l-5.869,1.572v30.289Zm2.288-67.014,6.168-2.118V359.866l-6.168,2.58Zm0-64.045v30.717l6.168-2.58V326.2Zm-10.446-27.306-5.548,3.158v29.494l5.548-2.74Zm-7.836,131.923-5.287,1.416v29.13l5.287-1.019Zm7.836-67.048-5.548,2.321v29.645l5.548-1.9Zm-5.548-29.673v29.512l5.548-2.32v-29.93Zm0,157.9,5.548-.65V464.21l-5.548,1.07Zm5.548-33.159V431.764l-5.548,1.485v29.7Zm-13.123,34.046,5.287-.619V465.72l-5.287,1.019Zm5.287-93.938-5.287,1.815v29.108l5.287-1.416Zm0-63.714-5.287,2.61v28.941l5.287-2.212Zm0,31.821-5.287,2.212v29.076l5.287-1.815Zm0-63.694-5.287,3.008v28.923l5.287-2.61Z",
    transform: "translate(-289.341 -200.271)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(78.76 69.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M380.95,319.35l-6.236-2.375v32.074l6.236,2.011Z",
    transform: "translate(-356.981 -274.593)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M380.95,289.481l-6.236-2.739v32.141l6.236,2.375Z",
    transform: "translate(-356.981 -278.95)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M373.526,286.219l-6.441-2.83V316.04l6.441,2.454Z",
    transform: "translate(-358.08 -279.433)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M373.526,316.522l-6.441-2.453v32.585l6.441,2.077Z",
    transform: "translate(-358.08 -275.012)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M367.084,377.392l6.441,1.7V346.728l-6.441-2.077Z",
    transform: "translate(-358.08 -270.605)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M374.714,379.342l6.236,1.647V349.122l-6.236-2.011Z",
    transform: "translate(-356.981 -270.25)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M395.117,295.7l-5.743-2.523v31.161l5.743,2.188Z",
    transform: "translate(-354.868 -278.022)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M401.909,329.058v-30.37l-5.515-2.422v30.692Z",
    transform: "translate(-353.857 -277.578)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M388.125,292.633l-5.961-2.619v31.644l5.961,2.27Z",
    transform: "translate(-355.907 -278.479)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M389.374,353.653l5.743,1.853V324.746l-5.743-2.188Z",
    transform: "translate(-354.868 -273.789)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M382.165,351.389l5.961,1.922V322.083l-5.961-2.27Z",
    transform: "translate(-355.907 -274.184)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M373.526,377.037l-6.441-1.7v32.775l1.6.329,4.842-9.653Z",
    transform: "translate(-358.08 -266.183)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M388.125,351.437l-5.961-1.923v31.438l5.961-11.882Z",
    transform: "translate(-355.907 -269.904)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M380.95,379l-6.236-1.647v16.583L380.95,381.5Z",
    transform: "translate(-356.981 -265.893)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M367.084,406.024v1.18l.536-1.069Z",
    transform: "translate(-358.08 -261.761)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M401.909,327.333l-5.515-2.1V352L401.909,341Z",
    transform: "translate(-353.857 -273.403)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M389.374,351.839v12.334l5.325-10.617Z",
    transform: "translate(-354.868 -269.569)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M365.93,412v-6.212l-6.716-1.382v20.983Z",
    transform: "translate(-359.214 -261.994)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M365.93,313.629l-6.716-2.559v33.111l6.716,2.165Z",
    transform: "translate(-359.214 -275.444)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M365.93,344.279l-6.716-2.165v33.265l6.716,1.774Z",
    transform: "translate(-359.214 -270.971)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M359.214,406.558l6.716,1.382V375.031l-6.716-1.773Z",
    transform: "translate(-359.214 -266.483)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M365.93,282.882l-6.716-2.951v33.177l6.716,2.559Z",
    transform: "translate(-359.214 -279.932)",
    fill: "rgba(222,247,255,0.65)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(8.203 72.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M316.883,295.405l-5.869,3.34V328.83l5.869-2.9Z",
    transform: "translate(-295.603 -280.374)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M316.883,324.317l-5.869,2.9v30.1l5.869-2.456Z",
    transform: "translate(-295.603 -276.208)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M318.144,354.43l6.168-2.58V320.669l-6.168,3.045Z",
    transform: "translate(-294.576 -276.734)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M304.165,388.133l5.548-1.9V356.166l-5.548,2.322Z",
    transform: "translate(-296.59 -271.618)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M309.713,299.463l-5.548,3.158v29.494l5.548-2.74Z",
    transform: "translate(-296.59 -279.79)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M309.713,327.838l-5.548,2.738v29.512l5.548-2.321Z",
    transform: "translate(-296.59 -275.701)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M324.312,291.2l-6.168,3.509v30.7l6.168-3.044Z",
    transform: "translate(-294.576 -280.981)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M340.079,314.8V282.268l-6.865,3.905v32.012Z",
    transform: "translate(-292.404 -282.268)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M332.033,286.818l-6.5,3.7v31.35l6.5-3.208Z",
    transform: "translate(-293.511 -281.612)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M325.535,351.439l6.5-2.718V316.877l-6.5,3.209Z",
    transform: "translate(-293.511 -277.28)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M324.538,289.475l0-.006v.006Z",
    transform: "translate(-293.655 -281.23)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M311.014,385.872l5.869-2.015V353.184l-5.869,2.456Z",
    transform: "translate(-295.603 -272.048)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M302.83,331.219l-5.286,2.61V362.77l5.286-2.211Z",
    transform: "translate(-297.544 -275.213)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M324.312,350.092l-6.168,2.58v30.846l1.05-.361,5.117-10.2Z",
    transform: "translate(-294.576 -272.494)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M316.883,382.108l-5.869,2.016V396.9l5.869-11.7Z",
    transform: "translate(-295.603 -267.88)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M340.079,312.928l-6.865,3.39v32.015l5.016-2.1,1.848-3.685Z",
    transform: "translate(-292.404 -277.849)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M333.214,346.223v5.42l3.441-6.859Z",
    transform: "translate(-292.404 -273.258)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M332.033,346.879l-6.5,2.718v19.261l6.5-12.955Z",
    transform: "translate(-293.511 -272.957)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M297.544,390.32l5.286-1.815V359.032l-5.286,2.211Z",
    transform: "translate(-297.544 -271.205)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M302.83,303.361l-5.286,3.008v28.923l5.286-2.61Z",
    transform: "translate(-297.544 -279.228)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M302.83,386.908l-5.286,1.814v29.109l5.274-1.413.012-.026Z",
    transform: "translate(-297.544 -267.188)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M297.544,422.869l3.9-7.776-3.9,1.046Z",
    transform: "translate(-297.544 -263.126)",
    fill: "rgba(222,247,255,0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M309.713,384.557l-5.548,1.9v25.709l5.548-11.061Z",
    transform: "translate(-296.59 -267.527)",
    fill: "rgba(222,247,255,0.65)"
  })))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M235.1,470.745,130.124,487.788V461.145L235.1,431.767Z",
    transform: "translate(-125.548 -152.877)",
    fill: "rgba(46,173,212,0.46)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M130.124,464.388l98.419,6.76,6.554-1.07V434.139l-104.973,28.52Z",
    transform: "translate(-125.548 -152.535)",
    fill: "rgba(46,173,212,0.46)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(4.576 292.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M235.177,443.392,130.124,468.349v1.175l104.973-24.9v-.682Z",
    transform: "translate(-130.124 -443.392)",
    fill: "rgba(46,173,212,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M130.124,475.389,235.1,453.85v-.693l.073-.579L130.124,474.22Z",
    transform: "translate(-130.124 -442.068)",
    fill: "rgba(46,173,212,0.46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(17.957 286.062)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M190.954,441.35l-11.946,3.343L164.607,480l11.333-1.84Z",
    transform: "translate(-138.536 -437.558)",
    fill: "rgba(46,173,212,0.46)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M141.82,483.266l11.334-1.84,13.6-33.355-11.947,3.344Z",
    transform: "translate(-141.82 -436.589)",
    fill: "rgba(46,173,212,0.46)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M202.082,438.035l-5.247,1.469-15.441,37.856,4.979-.808Z",
    transform: "translate(-136.117 -438.035)",
    fill: "rgba(46,173,212,0.46)"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M235.674,437.812l-109.55,28.961v-8.261l109.55-33.037Z",
    transform: "translate(-126.124 -153.784)",
    fill: "rgba(46,173,212,0.46)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M221.894,471.705l65.492,4.525V439.222l-65.492-7.983Z",
    transform: "translate(-112.323 -152.953)",
    fill: "rgba(46,173,212,0.46)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(109.571 292.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M287.386,459.571v-1.15l-65.441-5.843-.052.57v.574Z",
    transform: "translate(-221.894 -442.068)",
    fill: "rgba(46,173,212,0.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M287.386,450.132l-65.434-6.741-.058.569v.574l65.492,6.748Z",
    transform: "translate(-221.894 -443.392)",
    fill: "rgba(46,173,212,0.46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(110.811 280.15)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M222.978,471.557l14.882,1.028,13.774-37.935-14.61-1.781Z",
    transform: "translate(-222.978 -432.868)",
    fill: "rgba(46,173,212,0.46)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M268.205,436.677l-7.3-.891-13.535,37.277,7.441.514Z",
    transform: "translate(-219.463 -432.448)",
    fill: "rgba(46,173,212,0.46)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M280.846,438.224l-.451-.055-13.116,36.125,13.567.937Z",
    transform: "translate(-216.594 -432.104)",
    fill: "rgba(46,173,212,0.46)"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M235.674,473.006,126.124,488.67V480.4l109.55-19.741Z",
    transform: "translate(-126.124 -148.713)",
    fill: "rgba(46,173,212,0.46)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M291.87,477.332,221.894,473V460.685l69.976,5.454Z",
    transform: "translate(-112.323 -148.709)",
    fill: "rgba(46,173,212,0.46)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M291.87,445.866l-69.976-8V425.515l69.976,9.127Z",
    transform: "translate(-112.323 -153.778)",
    fill: "rgba(46,173,212,0.46)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M235.751,435.287,126.124,464.631v.728l109.627-28.983Z",
    transform: "translate(-126.124 -152.37)",
    fill: "rgba(46,173,212,0.46)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M235.751,461.7,126.124,481.108V480.4l109.627-19.755Z",
    transform: "translate(-126.124 -148.715)",
    fill: "rgba(46,173,212,0.46)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M291.861,444.456l-69.9-7.989V435.3l69.9,8.1Z",
    transform: "translate(-112.314 -152.367)",
    fill: "rgba(46,173,212,0.46)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M221.96,461.7l69.9,5.355v-.92l-69.9-5.448Z",
    transform: "translate(-112.314 -148.709)",
    fill: "rgba(46,173,212,0.46)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M192.86,516.058l-41.484.067V491.8l41.484-4.086Z",
    transform: "translate(-122.486 -144.814)",
    fill: "rgba(46,173,212,0.46)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M192.86,493.012v-5.3L151.375,491.8h0Z",
    transform: "translate(-122.486 -144.814)",
    fill: "rgba(46,173,212,0.46)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M168.032,515.771l-1.244,0V489.783l1.244-.122Z",
    transform: "translate(-120.264 -144.534)",
    fill: "rgba(46,173,212,0.46)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M165.423,502.729c0,.716-.31,1.308-.691,1.324s-.692-.549-.692-1.262.311-1.305.692-1.324S165.423,502.012,165.423,502.729Z",
    transform: "translate(-120.661 -142.833)",
    fill: "rgba(46,173,212,0.46)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M170.4,502.512c0,.732-.324,1.338-.722,1.351s-.721-.559-.721-1.287.324-1.333.721-1.351S170.4,501.78,170.4,502.512Z",
    transform: "translate(-119.953 -142.867)",
    fill: "rgba(46,173,212,0.46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(95.259 328.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M214.419,492.1c2.935,6.884,9.183,10.818,13.958,8.782s6.269-9.264,3.334-16.149-9.181-10.819-13.957-8.782S211.487,485.214,214.419,492.1Z",
    transform: "translate(-208.876 -475.414)",
    fill: "rgba(46,173,212,0.46)",
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M226.441,488.85c-2.579,5.177-1.76,10.825,1.834,12.614s8.592-.961,11.171-6.139,1.757-10.824-1.835-12.612S229.019,483.672,226.441,488.85Z",
    transform: "translate(-207.143 -474.44)",
    fill: "rgba(46,173,212,0.46)",
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M213.237,499.436c3.118,1.76,6.632,1.434,7.853-.73s-.318-5.337-3.433-7.1-6.632-1.431-7.854.731S210.12,497.676,213.237,499.436Z",
    transform: "translate(-209.385 -473.243)",
    fill: "rgba(46,173,212,0.46)",
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(12.331 7.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M225.863,516.492c.158.04.368-.173.557-.552a5.377,5.377,0,0,0,.453-1.542s.073-.486.163-1.34.186-2.072.216-3.533-.008-3.169-.152-4.987a55.272,55.272,0,0,0-.746-5.656c-.35-1.907-.8-3.8-1.3-5.542-.063-.22-.121-.435-.183-.649s-.133-.425-.195-.635c-.133-.415-.254-.828-.387-1.22-.27-.787-.513-1.538-.776-2.213l-.364-.975c-.12-.309-.24-.6-.348-.874-.223-.546-.411-1.024-.586-1.41-.338-.773-.532-1.216-.532-1.216-.5-1.119-1.1-1.932-1.31-1.832l-.132.063c-.215.1.029,1.074.524,2.172,0,0,.183.442.5,1.209.165.383.34.858.55,1.4.1.272.216.557.327.865s.223.628.34.965c.247.672.47,1.414.724,2.189.122.39.235.795.356,1.207.058.207.12.414.178.624s.113.426.17.642c.457,1.723.867,3.581,1.176,5.453a53.444,53.444,0,0,1,.628,5.533,48.336,48.336,0,0,1,.061,4.844c-.055,1.415-.17,2.588-.269,3.4s-.182,1.276-.182,1.276c-.172,1.174-.148,2.147.16,2.227Z",
    transform: "translate(-220.162 -482.308)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(4.464 21.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M227.8,501.7c.126-.154-.145-.58-.612-.921,0,0-.184-.136-.513-.359s-.8-.54-1.379-.91c-.289-.178-.608-.368-.942-.573s-.7-.4-1.067-.605c-.094-.052-.186-.1-.28-.159s-.195-.1-.29-.149l-.593-.305c-.2-.1-.4-.208-.6-.3s-.41-.193-.614-.292c-1.635-.779-3.311-1.456-4.544-1.985-.155-.067-.3-.131-.442-.189s-.269-.126-.394-.182c-.243-.113-.463-.206-.633-.295l-.538-.278c-.125-.064-.241-.128-.35-.182a2.231,2.231,0,0,0-.3-.12c-.182-.058-.316-.063-.357,0l-.051.073c-.04.063.023.177.158.319a2.75,2.75,0,0,0,.255.225,2.081,2.081,0,0,0,.343.224s.2.111.554.3c.176.1.4.2.643.323.126.059.256.127.4.192s.287.129.443.2c1.233.565,2.877,1.276,4.471,2.083l.6.3c.2.1.389.211.583.312l.57.312.281.153c.092.054.182.109.273.161.356.215.7.417,1.029.618s.627.4.908.584c.55.373,1.01.685,1.321.916s.49.363.49.363c.455.329.9.484,1.029.329Z",
    transform: "translate(-213.287 -493.843)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(5.321 23.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M218.573,496.141a.272.272,0,0,0-.331-.177s-.058.015-.164.039c-.052.014-.117.029-.188.045l-.248.049c-.362.073-.851.156-1.346.223s-.99.129-1.364.168-.621.065-.621.065c-.161.013-.288.106-.276.2l.007.058c.015.1.144.164.3.151l.628-.03c.378-.021.881-.048,1.384-.092s1.01-.1,1.388-.151l.259-.036.2-.036.175-.031a.265.265,0,0,0,.233-.294Z",
    transform: "translate(-214.035 -495.957)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(15.375 8.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M223.136,489.948c.145.071.352-.055.452-.283,0,0,.153-.358.344-.907a20.045,20.045,0,0,0,.6-2.039,19.718,19.718,0,0,0,.386-2.087c.032-.29.056-.53.071-.7s.016-.263.016-.263c.019-.247-.061-.451-.176-.455l-.074,0c-.118,0-.23.178-.248.414,0,0-.009.094-.026.256s-.057.4-.1.67a18.793,18.793,0,0,1-.465,2,19.925,19.925,0,0,1-.672,1.944c-.211.518-.371.852-.371.852a.387.387,0,0,0,.087.51Z",
    transform: "translate(-222.823 -483.211)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(18.499 17.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M225.58,503.514c-.059-.108-.015-.259.1-.416a2.194,2.194,0,0,1,.514-.469l.126-.079a4.013,4.013,0,0,0,.352-.238,11.87,11.87,0,0,0,1.182-.959,14.879,14.879,0,0,0,2.857-3.677,20.3,20.3,0,0,0,1.1-2.273c.3-.748.548-1.466.735-2.088s.317-1.148.4-1.516.126-.579.126-.579c.1-.539.292-.953.47-.936l.108.011c.18.019.265.5.159,1.061,0,0-.035.219-.111.6s-.194.93-.367,1.579-.4,1.4-.7,2.185a21.069,21.069,0,0,1-1.077,2.411,17.251,17.251,0,0,1-1.407,2.254,13.965,13.965,0,0,1-1.531,1.764,12.911,12.911,0,0,1-1.262,1.088c-.154.127-.292.209-.379.273s-.136.095-.136.095a1.676,1.676,0,0,1-.7.28c-.2.029-.357-.01-.415-.118Z",
    transform: "translate(-225.554 -490.283)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(21.954 17.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M230.906,497.605c.157-.038.235-.267.172-.513,0,0-.024-.1-.073-.263s-.124-.406-.2-.692-.181-.621-.3-.976-.238-.733-.36-1.112-.237-.757-.367-1.107-.244-.677-.347-.96l-.338-.934c-.082-.239-.236-.4-.347-.359l-.07.024c-.11.042-.137.267-.057.5,0,0,.118.378.3.943.086.28.191.611.3.962s.206.735.314,1.113l.308,1.119c.1.355.176.692.248.979s.13.524.172.692l.064.261c.059.24.238.406.4.367Z",
    transform: "translate(-228.574 -490.682)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(25.532 16.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M231.812,494.438c.074.144.307.171.508.054,0,0,.311-.189.749-.5a16.628,16.628,0,0,0,1.532-1.237,18.121,18.121,0,0,0,1.375-1.4c.17-.206.312-.376.413-.5s.15-.193.15-.193c.142-.175.182-.376.087-.45l-.057-.045c-.094-.071-.28.007-.418.176,0,0-.057.066-.155.182s-.248.27-.426.458a17.087,17.087,0,0,1-1.389,1.287,16.077,16.077,0,0,1-1.524,1.113c-.435.277-.733.436-.733.436a.365.365,0,0,0-.2.445Z",
    transform: "translate(-231.7 -490.139)",
    fill: "rgba(46,173,212,0.46)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(203.313 311.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M342.35,483.6c-4.176,9.8-13.068,15.4-19.863,12.5s-8.919-13.181-4.745-22.981,13.066-15.394,19.861-12.5S346.521,473.8,342.35,483.6Z",
    transform: "translate(-302.132 -459.855)",
    fill: "rgba(46,173,212,0.46)",
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M324.473,478.975c3.67,7.368,2.5,15.4-2.61,17.951s-12.226-1.367-15.9-8.738-2.5-15.4,2.611-17.946S320.8,471.608,324.473,478.975Z",
    transform: "translate(-303.829 -458.47)",
    fill: "rgba(46,173,212,0.46)",
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M342.565,494.04c-4.436,2.5-9.438,2.041-11.173-1.04s.451-7.595,4.885-10.1,9.438-2.037,11.177,1.04S347,491.535,342.565,494.04Z",
    transform: "translate(-299.942 -456.767)",
    fill: "rgba(46,173,212,0.46)",
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(20.458 11.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M323.7,518.313c-.225.055-.525-.246-.794-.787a7.7,7.7,0,0,1-.644-2.195s-.105-.693-.231-1.908-.267-2.947-.308-5.026.011-4.51.216-7.1A78.55,78.55,0,0,1,323,493.25c.5-2.714,1.145-5.4,1.852-7.886.09-.313.174-.618.261-.923s.19-.607.277-.9c.189-.592.362-1.177.55-1.736.386-1.12.73-2.189,1.1-3.148.181-.484.352-.949.518-1.389s.341-.851.493-1.242c.319-.777.586-1.458.834-2.006.482-1.1.759-1.732.759-1.732.717-1.591,1.564-2.749,1.864-2.606l.187.09c.305.147-.04,1.528-.745,3.089,0,0-.261.629-.719,1.722-.234.544-.484,1.221-.782,1.99-.143.389-.309.8-.466,1.231s-.319.9-.484,1.375c-.351.954-.669,2.01-1.03,3.113-.175.556-.334,1.13-.508,1.717-.082.294-.169.589-.255.888s-.159.605-.24.912c-.651,2.452-1.234,5.1-1.674,7.762a76.091,76.091,0,0,0-.895,7.874c-.156,2.523-.165,4.877-.086,6.892s.241,3.684.382,4.845.26,1.816.26,1.816c.245,1.67.208,3.056-.228,3.169Z",
    transform: "translate(-321.71 -469.666)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(21.06 30.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M322.279,497.257c-.177-.22.207-.825.872-1.31,0,0,.262-.194.729-.513s1.144-.768,1.962-1.294c.412-.255.864-.525,1.339-.816s.992-.563,1.52-.862c.133-.073.267-.149.4-.225s.277-.142.412-.212c.279-.144.559-.291.842-.435s.569-.3.857-.431.582-.276.875-.416c2.326-1.106,4.71-2.072,6.467-2.824.22-.1.428-.187.627-.27s.383-.177.563-.256c.343-.162.658-.294.9-.422l.764-.4c.179-.09.343-.182.5-.257a3.488,3.488,0,0,1,.428-.172c.26-.083.449-.089.508,0l.072.105c.057.088-.031.251-.223.452a3.768,3.768,0,0,1-.364.321,2.99,2.99,0,0,1-.488.32s-.286.157-.788.429c-.25.14-.562.282-.915.459-.179.085-.364.182-.564.273s-.408.184-.63.286c-1.755.8-4.1,1.816-6.362,2.966-.285.142-.567.285-.85.427s-.555.3-.831.445-.544.3-.811.444c-.135.074-.267.145-.4.218s-.26.156-.388.23c-.508.307-1,.6-1.464.88s-.892.571-1.292.829c-.785.531-1.438.975-1.882,1.3s-.7.517-.7.517c-.65.468-1.284.689-1.466.468Z",
    transform: "translate(-322.236 -486.081)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(34.017 33.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M333.622,489.351a.388.388,0,0,1,.471-.252l.233.056c.072.018.165.04.266.063s.222.043.354.071c.515.1,1.211.22,1.914.317s1.408.183,1.942.239.884.094.884.094c.229.017.41.151.391.286l-.01.082c-.021.139-.2.231-.427.215,0,0-.356-.018-.894-.041s-1.253-.071-1.969-.131-1.437-.136-1.975-.216l-.37-.049c-.11-.021-.206-.038-.284-.05l-.248-.045a.375.375,0,0,1-.333-.418Z",
    transform: "translate(-333.561 -489.09)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(23.114 12.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M326.7,480.538c-.207.1-.5-.078-.643-.4,0,0-.219-.509-.491-1.291a28.478,28.478,0,0,1-.857-2.9,27.928,27.928,0,0,1-.549-2.97c-.046-.412-.079-.754-.1-.993s-.022-.375-.022-.375c-.029-.35.086-.642.251-.648l.105-.007c.169-.007.327.255.353.59,0,0,.014.134.038.364s.081.563.143.954a26.371,26.371,0,0,0,.661,2.849,27.9,27.9,0,0,0,.955,2.766c.3.738.529,1.214.529,1.214a.552.552,0,0,1-.124.726Z",
    transform: "translate(-324.031 -470.951)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(9.978 24.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M324.316,499.842c.085-.153.021-.368-.137-.591a3.123,3.123,0,0,0-.73-.668s-.063-.038-.181-.112-.3-.18-.5-.339a17.052,17.052,0,0,1-1.683-1.365,21.233,21.233,0,0,1-4.066-5.232,29.175,29.175,0,0,1-1.559-3.235c-.433-1.066-.778-2.086-1.044-2.972s-.452-1.633-.573-2.157-.177-.824-.177-.824c-.143-.767-.417-1.357-.669-1.331l-.154.015c-.255.03-.378.715-.225,1.509,0,0,.05.311.158.86s.277,1.325.523,2.247.573,1.987.993,3.109a29.818,29.818,0,0,0,1.532,3.43,24.576,24.576,0,0,0,2,3.209,20.041,20.041,0,0,0,2.178,2.51,18.629,18.629,0,0,0,1.8,1.549c.22.18.416.3.538.388s.195.135.195.135a2.393,2.393,0,0,0,1,.4c.289.041.507-.015.593-.167Z",
    transform: "translate(-312.55 -481.015)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(13.271 24.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M315.7,491.435c-.224-.054-.334-.38-.245-.729,0,0,.035-.141.1-.376s.176-.577.289-.984.259-.883.42-1.39.339-1.042.515-1.581.336-1.079.521-1.575.348-.966.494-1.366l.481-1.33c.117-.341.335-.571.493-.511l.1.034c.157.061.194.38.081.715,0,0-.168.539-.421,1.341-.122.4-.271.87-.431,1.368s-.293,1.047-.445,1.586-.3,1.082-.438,1.593-.252.985-.354,1.393-.185.746-.245.985-.09.371-.09.371c-.083.342-.339.578-.563.524Z",
    transform: "translate(-315.428 -481.583)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(4.69 23.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M314.853,486.926c-.105.2-.436.245-.723.078,0,0-.443-.269-1.066-.714a23.636,23.636,0,0,1-2.18-1.761,25.62,25.62,0,0,1-1.958-2l-.588-.708c-.137-.173-.213-.274-.213-.274-.2-.248-.26-.535-.123-.64l.08-.063c.134-.1.4.01.6.252l.221.258c.146.159.352.384.6.651a24.32,24.32,0,0,0,1.978,1.832,22.508,22.508,0,0,0,2.168,1.584c.619.395,1.044.621,1.044.621a.517.517,0,0,1,.285.634Z",
    transform: "translate(-307.928 -480.81)",
    fill: "rgba(46,173,212,0.46)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(591.017 334.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M665.9,494.974c-2.516,5.9-7.87,9.269-11.962,7.526s-5.371-7.938-2.858-13.839,7.868-9.27,11.962-7.525S668.407,489.075,665.9,494.974Z",
    transform: "translate(-641.677 -480.676)",
    fill: "rgba(46,173,212,0.46)",
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M655.13,492.189c2.21,4.437,1.509,9.275-1.571,10.81s-7.362-.825-9.573-5.263-1.506-9.274,1.573-10.806S652.921,487.753,655.13,492.189Z",
    transform: "translate(-642.698 -479.842)",
    fill: "rgba(46,173,212,0.46)",
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M666.026,501.26c-2.673,1.508-5.683,1.23-6.729-.626s.27-4.573,2.941-6.082,5.685-1.228,6.73.626S668.7,499.752,666.026,501.26Z",
    transform: "translate(-640.358 -478.816)",
    fill: "rgba(46,173,212,0.46)",
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(12.319 6.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M654.665,515.876c-.137.034-.318-.147-.478-.474a4.592,4.592,0,0,1-.389-1.32s-.063-.417-.138-1.15-.161-1.773-.185-3.026.006-2.715.129-4.273a47.268,47.268,0,0,1,.641-4.848c.3-1.635.689-3.254,1.115-4.749.054-.188.1-.372.157-.556s.113-.365.167-.543c.115-.357.218-.709.331-1.046.232-.674.44-1.318.663-1.894.11-.292.213-.571.314-.838s.206-.513.3-.747c.192-.468.352-.879.5-1.208.288-.664.455-1.043.455-1.043.432-.959.944-1.656,1.122-1.569l.115.054c.183.088-.025.919-.45,1.86,0,0-.157.379-.434,1.037-.141.328-.291.734-.471,1.2-.085.233-.185.478-.279.74s-.192.54-.293.828c-.21.576-.4,1.212-.619,1.875-.105.334-.2.681-.306,1.034-.049.176-.1.354-.151.534s-.1.364-.148.549c-.391,1.476-.742,3.068-1.008,4.673a45.552,45.552,0,0,0-.537,4.742,41.213,41.213,0,0,0-.054,4.151c.047,1.212.146,2.217.23,2.916s.157,1.094.157,1.094c.148,1.006.127,1.841-.136,1.909Z",
    transform: "translate(-653.466 -486.584)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(12.683 18.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M653.81,503.2c-.107-.133.123-.5.523-.789,0,0,.158-.116.439-.308s.689-.463,1.183-.779c.247-.153.518-.316.8-.492s.6-.339.915-.518c.081-.044.161-.089.241-.136s.166-.085.248-.126c.168-.087.338-.176.508-.263s.341-.179.516-.26l.527-.25c1.4-.667,2.835-1.248,3.892-1.7.131-.057.257-.112.378-.161s.23-.107.34-.156c.206-.1.4-.176.541-.254l.46-.238c.108-.054.208-.109.3-.154a2.106,2.106,0,0,1,.256-.1c.157-.049.271-.054.307,0l.045.063c.033.054-.021.152-.134.272a2.566,2.566,0,0,1-.22.195,2.018,2.018,0,0,1-.294.192s-.173.1-.475.257c-.151.085-.339.17-.551.278-.108.05-.219.109-.34.164l-.38.173c-1.057.484-2.466,1.094-3.831,1.785l-.513.258c-.169.087-.333.181-.5.268s-.328.178-.49.268c-.08.045-.161.088-.241.132s-.157.093-.234.138c-.3.184-.6.357-.881.53s-.538.343-.777.5c-.474.319-.867.587-1.133.786s-.421.311-.421.311c-.39.281-.772.414-.882.281Z",
    transform: "translate(-653.784 -496.468)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(20.485 20.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M660.64,498.438a.235.235,0,0,1,.284-.153s.049.014.141.036l.16.038c.063.011.133.025.213.042.31.062.729.132,1.153.191s.847.11,1.168.144l.532.056c.138.009.248.092.237.172l-.007.05c-.013.083-.122.14-.256.129,0,0-.215-.011-.539-.025s-.753-.042-1.186-.079-.865-.082-1.189-.13l-.222-.03-.172-.031-.15-.026a.225.225,0,0,1-.2-.252Z",
    transform: "translate(-660.603 -498.279)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(13.918 7.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M656.471,493.129c-.124.062-.3-.047-.387-.242,0,0-.133-.307-.3-.777a17.522,17.522,0,0,1-.847-3.535c-.027-.248-.049-.454-.063-.6s-.014-.224-.014-.224c-.015-.211.054-.388.152-.39l.063,0c.1,0,.2.153.214.356,0,0,.009.08.023.219s.049.34.085.574a15.658,15.658,0,0,0,.4,1.716,16.838,16.838,0,0,0,.573,1.666c.182.444.318.731.318.731.082.182.051.374-.074.437Z",
    transform: "translate(-654.863 -487.357)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(6.008 14.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M655.036,504.754c.05-.092.013-.221-.083-.355a1.83,1.83,0,0,0-.441-.4l-.106-.069a2.8,2.8,0,0,1-.3-.2,10.066,10.066,0,0,1-1.012-.822,12.727,12.727,0,0,1-2.448-3.151,17.383,17.383,0,0,1-.94-1.948c-.261-.642-.469-1.256-.629-1.788s-.271-.984-.344-1.3-.107-.5-.107-.5c-.085-.461-.251-.817-.4-.8l-.094.009c-.151.017-.228.431-.136.909,0,0,.032.188.1.518s.168.8.316,1.352.343,1.2.6,1.873a18.626,18.626,0,0,0,.923,2.065,14.59,14.59,0,0,0,1.207,1.932,11.941,11.941,0,0,0,1.311,1.513,11.384,11.384,0,0,0,1.081.932c.133.107.25.178.325.232s.116.081.116.081a1.4,1.4,0,0,0,.6.24c.175.025.307-.008.358-.1Z",
    transform: "translate(-647.949 -493.418)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(7.991 14.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M649.849,499.692c-.134-.033-.2-.229-.148-.441,0,0,.023-.084.063-.225s.107-.347.174-.592.156-.533.255-.839.2-.627.308-.952.2-.648.314-.948.209-.582.3-.822c.172-.481.287-.8.287-.8.072-.2.2-.343.3-.308l.061.02c.094.038.117.229.049.431,0,0-.1.324-.255.807-.073.24-.162.524-.259.825s-.177.631-.269.954-.178.652-.263.959-.153.593-.213.84-.111.45-.148.594l-.055.222c-.049.207-.2.349-.338.316Z",
    transform: "translate(-649.683 -493.759)",
    fill: "rgba(46,173,212,0.46)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(2.825 14.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M649.337,496.978a.312.312,0,0,1-.435.046s-.266-.161-.642-.43a14.408,14.408,0,0,1-1.313-1.059,15.277,15.277,0,0,1-1.178-1.2l-.355-.427c-.083-.1-.128-.165-.128-.165-.123-.15-.156-.323-.073-.384l.047-.039c.08-.062.241.006.359.151l.133.155c.087.095.211.231.364.393a14.888,14.888,0,0,0,1.191,1.1,13.653,13.653,0,0,0,1.305.954c.373.237.628.373.628.373a.311.311,0,0,1,.172.382Z",
    transform: "translate(-645.167 -493.294)",
    fill: "rgba(46,173,212,0.46)"
  })))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M319.792,382.274l2.392-.9V260.127l-2.392,1.551Z",
    transform: "translate(-98.215 -177.612)",
    fill: "rgba(46,173,212,0.46)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M319.8,366.989l2.344-.883,26.94,6.937-2.383.811Z",
    transform: "translate(-98.214 -162.339)",
    fill: "rgba(46,173,212,0.46)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.3535c091.svg";
export { ForwardRef as ReactComponent };